import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api from "../api";
import { useI18n } from "../i18n";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LOGO_URL } from "../brand";
import { ArrowLeft } from "lucide-react";

export default function ResetPassword() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw.length < 8) { setError(t("passwordTooShort")); return; }
    if (pw !== pw2) { setError(t("passwordMismatch")); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      toast.success(t("passwordChanged"));
      navigate("/login");
    } catch (err) {
      setError(err.response?.data?.detail || t("resetInvalid"));
    } finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6">
      <div className="w-full max-w-sm fade-in">
        <div className="mb-8 flex justify-center"><div className="rounded-lg bg-[#F7F2EA] p-3"><img src={LOGO_URL} alt="Urban Dreams Home" className="h-14 w-auto object-contain" /></div></div>
        <h1 className="font-head text-2xl font-semibold text-slate-900">{t("resetPassword")}</h1>
        {!token ? (
          <p data-testid="reset-notoken" className="mt-6 text-sm text-rose-600">{t("resetInvalid")}</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div><Label>{t("newPassword")}</Label><Input data-testid="reset-password" type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="mt-1.5" required /></div>
            <div><Label>{t("confirmPassword")}</Label><Input data-testid="reset-password2" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="mt-1.5" required /></div>
            {error && <p data-testid="reset-error" className="text-sm font-medium text-rose-600">{error}</p>}
            <Button data-testid="reset-submit" type="submit" disabled={loading} className="w-full bg-primary hover:bg-primary/90">{loading ? "…" : t("changePassword")}</Button>
          </form>
        )}
        <Link to="/login" className="mt-6 flex items-center justify-center gap-1 text-sm text-slate-500 hover:text-primary"><ArrowLeft size={14} /> {t("backToLogin")}</Link>
      </div>
    </div>
  );
}
